import React from "react";
import { connect } from "react-redux";
import PeoplePicker, {
  mapDbUserForPeoplePicker,
} from "../formFields/PeoplePicker";
import { PermissionRole } from "../../GlobalConst/globalEnums";
import { Spinner, SpinnerSize } from "@fluentui/react";
import { MessageBar, MessageBarType, PrimaryButton } from "@fluentui/react";
import { ModalDialog } from "../formFields/Dialog";
import Api from "../../services/Api";

class PermissionRoles extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      administrators: [],
      contributors: [],
      readers: [],
      owners: [],
      approvers: [],
      isLoading: false,
      isSaving: false,
      message: null,
    };
  }

  componentDidMount() {
    this.setState({
      isLoading: true,
    });
    this.getUsersWithPermissionRoles();
  }

  getUsersWithPermissionRoles() {
    Api.get(`/Settings/Users?role=any`)
      .then((res) => res.data)
      .then((users) => {
        const administrators = users.reduce((users, user) => {
          if (user.role === PermissionRole.administrator) {
            users.push(mapDbUserForPeoplePicker(user));
          }
          return users;
        }, []);
        const approvers = users.reduce((users, user) => {
          if (user.role === PermissionRole.approver) {
            users.push(mapDbUserForPeoplePicker(user));
          }
          return users;
        }, []);
        const contributors = users.reduce((users, user) => {
          if (user.role === PermissionRole.contributor) {
            users.push(mapDbUserForPeoplePicker(user));
          }
          return users;
        }, []);
        const readers = users.reduce((users, user) => {
          if (user.role === PermissionRole.reader) {
            users.push(mapDbUserForPeoplePicker(user));
          }
          return users;
        }, []);
        const owners = users.reduce((users, user) => {
          if (user.role === PermissionRole.owner) {
            users.push(mapDbUserForPeoplePicker(user));
          }
          return users;
        }, []);

        this.setState({
          administrators,
          contributors,
          readers,
          approvers,
          owners,
          isLoading: false,
        });
      })
      .catch((error) => {
        this.setState({
          message: {
            type: MessageBarType.error,
            text: "Cannot get user settings from database: " + error,
          },
        });
      });
  }

  saveSettings = () => {
    this.setState({ isSaving: true, message: null });

    // if(!this.state.administrators.filter(u => u.id === this.props.currentUser.id).length &&
    //    !window.confirm('You will no longer be administrator (not including groups). Are you sure you want to continue?')) {
    //         this.setState({ isSaving: false });
    //         return;
    // }

    const users = [
      ...this.state.readers,
      ...this.state.contributors,
      ...this.state.owners,
      ...this.state.administrators,
      ...this.state.approvers,
    ];

    Api.post(`/Settings/Users`, users)
      .then((res) => res.data)
      .then((post) => {
        if (post === 200) {
          this.setState({
            isSaving: false,
            message: {
              type: MessageBarType.success,
              text: "Settings have been saved.",
            },
          });
        } else {
          this.setState({
            isSaving: false,
            message: {
              type: MessageBarType.error,
              text: "Cannot save settings: " + post.message,
            },
          });
        }
      })
      .catch((error) => {
        this.setState({ isSaving: false });
        console.log(error);
      });
  };

  onSelectedAdmin = (items) => {
    this.setState({
      administrators: items.map((u) => {
        u.role = PermissionRole.administrator;
        return u;
      }),
    });
  };
  onSelectedContributor = (items) => {
    this.setState({
      contributors: items.map((u) => {
        u.role = PermissionRole.contributor;
        return u;
      }),
    });
  };
  onSelectedReader = (items) => {
    this.setState({
      readers: items.map((u) => {
        u.role = PermissionRole.reader;
        return u;
      }),
    });
  };
  onSelectedOwner = (items) => {
    this.setState({
      owners: items.map((u) => {
        u.role = PermissionRole.owner;
        return u;
      }),
    });
  };

  onSelectedApprover = (items) => {
    this.setState({
      approvers: items.map((u) => {
        u.role = PermissionRole.approver;
        return u;
      }),
    });
  };

  isCurrentRoleRemoved = () => {
    return (
      (this.props.role === PermissionRole.administrator &&
        !this.state.administrators.filter(
          (u) => u.id === this.props.currentUser.id
        ).length) ||
      (this.props.role === PermissionRole.owner &&
        ![...this.state.administrators, ...this.state.owners].filter(
          (u) => u.id === this.props.currentUser.id
        ).length)
    );
  };

  render() {
    const message = this.state.message ? (
      <MessageBar messageBarType={this.state.message.type}>
        {this.state.message.text}
      </MessageBar>
    ) : null;

    return (
      <div>
        {this.state.isLoading ? (
          <Spinner style={{ margin: "200px" }} size={SpinnerSize.large} />
        ) : (
          <div className="settings-container">
            {this.props.role === PermissionRole.administrator && (
              <div className="settings-item">
                <div className="settings-item-title">Administrators</div>
                <PeoplePicker
                  defaultUsers={this.state.administrators}
                  onSelectedUsers={this.onSelectedAdmin}
                  includeGroups={true}
                />
              </div>
            )}
            <div className="settings-item">
              <div className="settings-item-title">Owners</div>
              <PeoplePicker
                defaultUsers={this.state.owners}
                onSelectedUsers={this.onSelectedOwner}
                includeGroups={true}
              />
            </div>
            <div className="settings-item">
              <div className="settings-item-title">Contributors</div>
              <PeoplePicker
                defaultUsers={this.state.contributors}
                onSelectedUsers={this.onSelectedContributor}
                includeGroups={true}
              />
            </div>
            <div className="settings-item">
              <div className="settings-item-title">Readers</div>
              <PeoplePicker
                defaultUsers={this.state.readers}
                onSelectedUsers={this.onSelectedReader}
                includeGroups={true}
              />
            </div>
            <div className="settings-item">
              <div className="settings-item-title">Approvers</div>
              <PeoplePicker
                defaultUsers={this.state.approvers}
                onSelectedUsers={this.onSelectedApprover}
                includeGroups={true}
              />
            </div>

            <div className="settings-btn">
              {this.state.isSaving ? (
                <Spinner size={SpinnerSize.large} />
              ) : this.isCurrentRoleRemoved() ? (
                <ModalDialog
                  title="Administrator warning"
                  text="You will no longer be administrator (not including groups). Are you sure you want to continue?"
                  buttonName="Save"
                  actionConfirmed={this.saveSettings}
                  btnPrimary={true}
                  onCancel={() => {
                    this.setState({ isSaving: false, message: null });
                  }}
                />
              ) : (
                <PrimaryButton onClick={this.saveSettings}>Save</PrimaryButton>
              )}
            </div>
            {message}
          </div>
        )}
      </div>
    );
  }
}
const mapStateToProps = (state) => ({
  currentUser: state.user.currentUser,
  role: state.user.role,
});

export default connect(mapStateToProps, null)(PermissionRoles);



// WEBPACK FOOTER //
// ./src/components/Settings/PermissionRoles.js